import { $$ } from 'utils/dom';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { SplitText } from 'gsap/SplitText';
import { viewport } from '../getViewport';

export const storyHeadline = () => {
  const animateHeadlines = headlines => {
    headlines.forEach(headline => {
      // eslint-disable-next-line no-unused-vars
      const splitText = SplitText.create(headline, {
        type: 'words',
        tag: 'span',
        wordsClass: 'story-headline__word',
      });

      const textTimeline = gsap.timeline();
      const words = splitText.words;

      words.forEach(word => {
        gsap.set(word, { yPercent: viewport.isReduced ? 0 : 100 });
      });

      textTimeline.to(words, {
        yPercent: 0,
        alpha: 1,
        stagger: {
          from: 'start',
          amount: 0.5,
        },
      });

      ScrollTrigger.create({
        animation: textTimeline,
        trigger: headline,
        start: () => 'top 90%',
        end: () => 'top top',
        toggleActions: 'play pause resume reverse',
      });
    });
  };

  const headlines = $$('.story-headline');

  if (headlines.length) {
    animateHeadlines(headlines);
  }
};
